import React from 'react'
import { useTranslation } from 'react-i18next'

import EmptySearchState from '../EmptySearchState'
import { getFilterEmptyState } from '../../common/helpers/filterEmptyState.helper'
import type { IFilterBundle } from './FilterPanel'

interface IProps {
  filters: IFilterBundle
  searchTerm?: string
  extraHasActive?: boolean
  onClear: () => void
  className?: string
}

const FilterEmptySearchState: React.FC<IProps> = ({
  filters,
  searchTerm,
  extraHasActive,
  onClear,
  className,
}) => {
  const { t } = useTranslation()
  const { title, action } = getFilterEmptyState(t, {
    filters,
    searchTerm,
    extraHasActive,
    onClear,
  })

  return (
    <EmptySearchState
      className={className}
      emptyText={title}
      clear={action && { text: action.caption, clearFunc: action.onClick }}
    />
  )
}

export default FilterEmptySearchState
